angular.module('app.directives').directive('broadcastGraph', ($timeout, StatsService) =>
    ({
        restrict: 'E',
        scope: {
            streamId: '@',
            broadcastId: '@',
            streamedAt: '@',
            isLive: '@',
            startsAt: '@',
            stopsAt: '@',
            originVersion: '@',
            isRtmp: '@',
        },
        controller($scope) {
            $scope.packetLossLoaded = false;
            $scope.packetLossOptions = {
                renderer: 'bar',
                height: 100,
                //max: 20, TODO: consider a way to dynamically set max to balance
                //         not over-emphasizing tiny packet losses but also not hide them entirely.
                //         Probably warrants other custom handling of massive spikes rather than
                //         just scaling axes.
            };
            $scope.packetLossSeries = [{
                data: [],
                name: 'video',
                color: '#ff0000'
            }, {
                data: [],
                name: 'audio',
                color: '#0000ff'
            }];
            $scope.packetLossFeatures = {
                xAxis: {
                    timeUnit: '15 minute'
                },
                hover: {
                    xFormatter: function(x) { return new Date( x * 1000 ).toLocaleString(); }
                },
                minimum_bar_width: 1
            };
            $scope.numPacketLossResults = null;


            $scope.transcodeDelayLoaded = false;
            $scope.transcodeDelayOptions = {
                renderer: 'line',
                height: 50
            };
            $scope.transcodeDelaySeries = [{
                data: [],
                name: 'delay',
                color: '#ffc107' //orange
            }];
            $scope.transcodeDelayFeatures = {
                hover: {
                  xFormatter: function(x) { return new Date( x * 1000 ).toLocaleString(); },
                  yFormatter: false,
                  formatter: function(series, x, y) {
                    const totalDelay = Math.round(1000.0 * y) / 1000.0;
                    if (totalDelay >= 30) {
                      return `<strong>Warning: Transcode delayed ${totalDelay} seconds. Could cause buffering`;
                    } else {
                      return `${totalDelay} seconds`;
                    }
                  }
                }
            };

            $scope.ingestLatencyLoaded = false;
            $scope.ingestLatencyOptions = {
                renderer: 'line',
                height: 50
            };
            $scope.ingestLatencySeries = [{
                data: [],
                name: 'latency',
                color: '#1AA8A1' //teal
            }];
            $scope.ingestLatencyFeatures = {
                hover: {
                  xFormatter: function(x) { return new Date( x * 1000 ).toLocaleString(); },
                  yFormatter: false,
                  formatter: function(series, x, y) {
                    const latency = Math.round(1000.0 * y) / 1000.0;
                    if (Math.abs(latency) < 1.0) {
                      return `${Math.round(1000.0 * latency)} ms`;
                    }
                    return `${latency} seconds`;
                  }
                }
            };

            $scope.packetsRxLoaded = false;
            $scope.packetsRxOptions = {
                renderer: 'line',
                height: 100
            };
            $scope.packetsRxSeries = [{
                data: [],
                name: 'video',
                color: '#ff0000'
            }, {
                data: [],
                name: 'audio',
                color: '#0000ff'
            }, {
                data: [],
                name: 'ancillary',
                color: '#00ff00'
            }];
            $scope.packetsRxFeatures = {
                hover: {
                    xFormatter: function(x) { return new Date( x * 1000 ).toLocaleString(); }
                }
            };

            $scope.timeoutId = null;
        },

        link(scope, element, attrs) {
            scope.parseGoTs = (ts) => {
                let vMs = 0;
                _.each(ts.match(/\d+(\.\d+)?[a-z]+/g), (component) => {
                    let m = component.match(/(\d+(?:\.\d+)?)([a-z]+)/);
                    if (m && m.length == 3) {
                        const n = parseFloat(m[1]);
                        const unit = m[2];
                        if (unit == 'h') {
                            vMs += n * 60 * 60 * 1000;
                        } else if (unit == 'm') {
                            vMs += n * 60 * 1000;
                        } else if (unit == 's') {
                            vMs += n * 1000;
                        }
                    }
                });
                return vMs;
            };

            scope.startsAtDate = new Date(scope.startsAt);
            scope.stopsAtDate = new Date(scope.stopsAt);
            if (scope.streamedAt) {
                scope.streamedAtDate = new Date(scope.streamedAt);
            } else {
                scope.streamedAtDate = null;
            }

            if (scope.originVersion <= 4) {
                scope.influxKeys = [
                    { field: 'derivative(sum("count"))', as: 'video-packet-loss',    value: 'origin.rtpbuf.packets_lost',       where: `"media" = 'video'` },
                    { field: 'derivative(sum("count"))', as: 'audio-packet-loss',    value: 'origin.rtpbuf.packets_lost',       where: `"media" = 'audio'` },
                    { field: 'derivative(sum("count"))', as: 'video-packets-rx',     value: 'origin.mux.packets_total',         where: `"index" = '0' AND "media" = 'media'` },
                    { field: 'derivative(sum("count"))', as: 'audio-packets-rx',     value: 'origin.mux.packets_total',         where: `"index" = '1' AND "media" = 'media'` },
                    { field: 'derivative(sum("count"))', as: 'ancillary-packets-rx', value: 'origin.mux.packets_total',         where: `"index" = '2' AND "media" = 'media'` },
                    { field: 'last("value")',            as: 'transcode-delay',      value: 'origin.transcode.delay_seconds',   where: "" },
                ];
                if (scope.isRtmp === 'true') {
                    scope.influxKeys.push({field: 'last("value")', as: 'ingest-latency', value: 'origin.rtmpsrc.packet_latency'});
                }
            } else {
                scope.influxKeys = [
                    { field: 'derivative(sum("count"))', as: 'video-packet-loss',    value: 'stream_ingest_service.stream.packets_lost',   where: `"element" = 'rtpbuf:video'` },
                    { field: 'derivative(sum("count"))', as: 'audio-packet-loss',    value: 'stream_ingest_service.stream.packets_lost',   where: `"element" = 'rtpbuf:audio'` },
                    { field: 'derivative(sum("count"))', as: 'video-packets-rx',     value: 'stream_ingest_service.stream.packets_total',  where: `"element" = 'mux:media' AND "index" = '0'` },
                    { field: 'derivative(sum("count"))', as: 'audio-packets-rx',     value: 'stream_ingest_service.stream.packets_total',  where: `"element" = 'mux:media' AND "index" = '1'` },
                    { field: 'derivative(sum("count"))', as: 'ancillary-packets-rx', value: 'stream_ingest_service.stream.packets_total',  where: `"element" = 'mux:media' AND "index" = '2'` },
                    { field: 'last("value")',            as: 'transcode-delay',      value: 'stream_collect_service.transcode_delay',      where: "" },
                ];
                if (scope.isRtmp === 'true') {
                    scope.influxKeys.push({field: 'last("value")', as: 'ingest-latency', value: 'stream_ingest_service.stream.packet_latency'});
                }
            }

            const refreshFn = function() {
                // Packet loss and RX come from stats
                var req_params = { datasource: 'origin', time: [`time > ${scope.startsAtDate.getTime() / 1000}s`], targets: scope.influxKeys };
                if (scope.originVersion <= 4) {
                    req_params.broadcastId = scope.broadcastId;
                } else {
                    req_params.stream = scope.streamId;
                }
                if (scope.stopsAtDate.getTime() < Date.now()) {
                    req_params.time.push(`time < ${scope.stopsAtDate.getTime() / 1000}s`);
                }
                StatsService.fetch(req_params).then(function(data) {
                    scope.packetLossLoaded = true;
                    scope.packetsRxLoaded = true;
                    scope.transcodeDelayLoaded = true;

                    // Packet loss
                    scope.packetLossSeries[0].data.length = 0;
                    scope.packetLossSeries[1].data.length = 0;
                    scope.numPacketLossResults = _.map([data['video-packet-loss'], data['audio-packet-loss']], (pairs) => {
                        return _.map(pairs, (v) => v || 0).reduce((a, b) => a + b, 0)
                    }).reduce((a, b) => a + b, 0);
                    if (scope.numPacketLossResults > 0) {
                        Array.prototype.push.apply(scope.packetLossSeries[0].data, _.map(data['video-packet-loss'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                        Array.prototype.push.apply(scope.packetLossSeries[1].data, _.map(data['audio-packet-loss'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    }

                    // Packets RX
                    scope.packetsRxSeries[0].data.length = 0;
                    scope.packetsRxSeries[1].data.length = 0;
                    scope.packetsRxSeries[2].data.length = 0;
                    Array.prototype.push.apply(scope.packetsRxSeries[0].data, _.map(data['video-packets-rx'], (v, k) => ({ x: parseInt(k), y: v / 10.0 })).sort((a, b) => a.x - b.x));
                    Array.prototype.push.apply(scope.packetsRxSeries[1].data, _.map(data['audio-packets-rx'], (v, k) => ({ x: parseInt(k), y: v / 10.0 })).sort((a, b) => a.x - b.x));
                    Array.prototype.push.apply(scope.packetsRxSeries[2].data, _.map(data['ancillary-packets-rx'], (v, k) => ({ x: parseInt(k), y: v / 10.0 })).sort((a, b) => a.x - b.x));

                    // Transcode delay
                    scope.transcodeDelaySeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.transcodeDelaySeries[0].data, _.map(data['transcode-delay'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));

                    if (scope.isRtmp === 'true') {
                        // Ingest latency (for RTMP sources)
                        scope.ingestLatencyLoaded = true;
                        scope.ingestLatencySeries[0].data.length = 0;
                        Array.prototype.push.apply(scope.ingestLatencySeries[0].data, _.map(data['ingest-latency'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    }
                });

                // Reload
                if (scope.isLive === 'true') {
                    scope.timeoutId = $timeout(refreshFn, 10000);
                }
            };
            refreshFn();

            /* This trick doesn't work reliably becuase the div inside the table can overflow still.
             * `table-layout: fixed` opens a whole new can of worms.  Ugh.
            angular.element($window).bind('resize', () =>
                scope.$apply(function() {
                    const containerWidth = $('.boxcaster-diagnostic-graph-cell')[0].getBoundingClientRect().width;
                    scope.packetLossOptions.width = containerWidth;
                    scope.packetsRxOptions.width = containerWidth;
                })
            );
            */

            return element.on('$destroy', function() {
                if (scope.timeoutId != null) {
                    return $timeout.cancel(scope.timeoutId);
                }
            });
        },

        template: `\
<div class="panel panel-default">
  <div class="panel-heading">
    Broadcast (Origin)
  </div>
  <div class="panel-body" id="backhaul-chart-panel" style="padding: 0px; position: relative; overflow: visible;">
    <table class="table" style="width: 100%; margin: 0px;">
      <tr ng-switch="packetLossLoaded" class="boxcaster-diagnostic-graph-row">
        <th class="boxcaster-diagnostic-graph-rowhead">Packet Loss</th>
        <td class="boxcaster-diagnostic-graph-cell" ng-switch-when="true">
          <app-rickshaw rickshaw-options="packetLossOptions" rickshaw-series="packetLossSeries" rickshaw-features="packetLossFeatures"></app-rickshaw>
          <div ng-show="numPacketLossResults == 0" class="bg-info" style="text-align: center;">
            <strong>No reported packet loss.</strong>
          </div>
        </td>
        <td ng-switch-default style="padding-left:10px;" class="boxcaster-diagnostic-graph-cell">
          Loading packet loss graph...
        </td>
      </tr>
      <tr ng-switch="packetsRxLoaded" class="boxcaster-diagnostic-graph-row">
        <th class="boxcaster-diagnostic-graph-rowhead">Packets Rx/s</th>
        <td class="boxcaster-diagnostic-graph-cell" ng-switch-when="true">
          <app-rickshaw rickshaw-options="packetsRxOptions" rickshaw-series="packetsRxSeries" rickshaw-features="packetsRxFeatures"></app-rickshaw>
        </td>
        <td ng-switch-default style="padding-left:10px;" class="boxcaster-diagnostic-graph-cell">
          Loading packets rx/s graph...
        </td>
      </tr>
      <tr ng-switch="transcodeDelayLoaded" class="boxcaster-diagnostic-graph-row">
        <th class="boxcaster-diagnostic-graph-rowhead">Transcode Delay</th>
        <td class="boxcaster-diagnostic-graph-cell" ng-switch-when="true">
          <app-rickshaw rickshaw-options="transcodeDelayOptions" rickshaw-series="transcodeDelaySeries" rickshaw-features="transcodeDelayFeatures"></app-rickshaw>
        </td>
        <td ng-switch-default style="padding-left:10px;" class="boxcaster-diagnostic-graph-cell">
          Loading transcode delay graph...
        </td>
      </tr>
      <tr ng-if="isRtmp === 'true'" ng-switch="ingestLatencyLoaded" class="boxcaster-diagnostic-graph-row">
        <th class="boxcaster-diagnostic-graph-rowhead">Ingest Latency</th>
        <td class="boxcaster-diagnostic-graph-cell" ng-switch-when="true">
          <app-rickshaw rickshaw-options="ingestLatencyOptions" rickshaw-series="ingestLatencySeries" rickshaw-features="ingestLatencyFeatures"></app-rickshaw>
        </td>
        <td ng-switch-default style="padding-left:10px;" class="boxcaster-diagnostic-graph-cell">
          Loading ingest latency graph...
        </td>
      </tr>
    </table>
  </div>
</div>\
`
    }));



// WEBPACK FOOTER //
// ./directives/broadcast_graph.js